module.exports = __webpack_public_path__ + "static/thumbnail-582ac24544993fc044dad5e865b13dc2.jpg";